import pathToRegexp from 'path-to-regexp'

export const formatTenDigitPhoneNumber = phoneStr =>
  phoneStr
    ? phoneStr.replace(/\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})/g, '($1) $2-$3')
    : phoneStr

export const formatCreditTransactionType = type => {
  if (type === 'TESTING' || type === 'ZENDESK' || type === 'JIRA_CONWEB') {
    return 'Foodsby Internal'
  } else if (type === 'USER_ACHIEVEMENT') {
    return 'Achievement'
  } else {
    return type
      .toLowerCase()
      .split('_')
      .map(part => {
        return part.charAt(0).toUpperCase() + part.slice(1)
      })
      .join(' ')
  }
}

export const convertOrderDetailItemsToCartMenuItems = orderDetailItems =>
  orderDetailItems.map(item => ({
    ...item,
    displayText: item.displayText,
    itemSubTotal: item.subTotal,
    fullSubTotal: item.fullSubTotal,
    modifierSubTotal: item.modifierSubTotal,
    menuItem: {
      ...item,
      displayText: item.displayText
    },
    specialInstructions: item.specialInstructions,
    modifiers: item.modifiers.map(mod => ({
      answers: mod.answers.map(ans => ({
        menuItem: {
          displayText: ans.displayText,
          price: ans.price
        }
      }))
    }))
  }))

export const formatUrl = (
  url,
  { orderId = 0, locationId = 0, dropoffId = 0, token, ...rest }
) => {
  const toPath = pathToRegexp.compile(url)
  return toPath({ orderId, locationId, dropoffId, token, ...rest })
}
